module.exports = __webpack_public_path__ + "static/media/8ruedas.01ada1e3.png";